// TODO: i18n
export const generateTimestampString =  (timestamp: number) => {
  const date = new Date(timestamp);

  return (
    <>
      {date.toLocaleDateString()} {date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
      })}
    </>
  )
}

/**
 * Given a timestamp returned by something like Date.now(), returns that time
 * formatted in MM/DD/YYYY format.
 * 
 * @param timestamp timestamp in ms elapsed since epoch
 */
export const generateDateString = (timestamp: number) => {
  const date = new Date(timestamp);

  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  const formattedDate = `${month}/${day}/${year}`;

  return formattedDate
}

/**
 * Given a candidate string, validates whether it is a valid email format. 
 * Used in `InputWithTags` component.
 * 
 * @param candidate candidate to validate
 * @returns boolean 
 */
export const onlyEmails = (candidate: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(candidate)
};